// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"353":"7586d195","851":"5b519afc"}[chunkId] + ".js";
};